import { Component } from '@angular/core';

@Component({
  selector: 'app-toolbar-layout',
  template: `
    <div id="app-container">
      <app-toolbar class="app-toolbar"></app-toolbar>
      <router-outlet></router-outlet>
    </div>
  `,
  styles: [
    `
    #app-container {
      height: 100%;
      width: 100%;
      padding:0;
      margin:0;
    }
    .app-toolbar {
      position: absolute;
      top: 0px;
      right: 0px;
      left: 0px;
      height: 3rem;
    }
    `
  ]
})

export class ToolbarLayoutComponent {

}
